module.exports = __webpack_public_path__ + "static/media/about.0a0307de.jpg";